// src/components/_v3/touristic-site/NearbyRail.jsx
import React from 'react';
import styled from 'styled-components';
import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {mediasTyped} from '../../../utils/media';
import {Card, Eyebrow, SectionHead} from '../../../_ui/_v3/primitives';

const RailStyled = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 230px;
  gap: 1rem;
  overflow-x: auto;
  padding-bottom: .3rem;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

const RelCardStyled = styled(Card).attrs({as: Link})`
  scroll-snap-align: start;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  box-shadow: none;
`;

const RelPhotoStyled = styled.div`
  height: 120px;
  background: ${props => props.theme.colors.paperSunk};
  img { width: 100%; height: 100%; object-fit: cover; }
`;

const RelBodyStyled = styled.div`
  padding: .85rem .9rem 1rem;
  display: grid;
  gap: .3rem;

  .cat {
    font-size: .66rem;
    font-weight: 700;
    letter-spacing: .03em;
    text-transform: uppercase;
    color: ${props => props.color || props.theme.colors.brandText};
  }
  .title { font-weight: 700; font-size: .95rem; }
  .meta {
    font-size: .78rem;
    color: ${props => props.theme.colors.inkFaint};
  }
`;

const nearbyImage = (site) =>
  (mediasTyped(site.medias || []).image || [])[0]?.url
  || (site.touristic_site_images && site.touristic_site_images[0] && site.touristic_site_images[0].url)
  || null;

const NearbyRail = ({sites}) => {
  const {t, i18n} = useTranslation(['touristic-site']);
  const location = useLocation();
  const previewSuffix = new URLSearchParams(location.search).has('preview_v3') ? '?preview_v3=1' : '';

  if (!sites || sites.length === 0) {
    return null;
  }
  return (
    <>
      <SectionHead>
        <Eyebrow>{t('v3.eyebrow.proximite')}</Eyebrow>
        <h2>{t('v3.section.proximite')}</h2>
      </SectionHead>
      <RailStyled>
        {sites.map((site) => {
          const category = (site.categories && site.categories[0]) || {};
          const image = nearbyImage(site);
          return (
            <RelCardStyled key={site.id} to={`/touristic-sites/${site.id}${previewSuffix}`}>
              <RelPhotoStyled>
                {image && <img src={image} alt={site[`title_${i18n.language}`] || site.title_fr || ''} loading="lazy" decoding="async" />}
              </RelPhotoStyled>
              <RelBodyStyled color={category.color}>
                {category.title && <span className="cat">{category.title}</span>}
                <span className="title">{site[`title_${i18n.language}`] || site.title_fr || site.title}</span>
                {site.city && <span className="meta">{site.city}</span>}
              </RelBodyStyled>
            </RelCardStyled>
          );
        })}
      </RailStyled>
    </>
  );
};

export default NearbyRail;
